import { z } from 'zod';
import { ActionSchema } from '../actions';

export const ButtonsBlockSchema = z.object({
  id: z.string().min(1),
  type: z.literal('buttons'),
  rect: z.object({
    x: z.number().int().nonnegative(),
    y: z.number().int().nonnegative(),
    w: z.number().int().positive(),
    h: z.number().int().positive()
  }),
  on: z.object({ tap: z.array(ActionSchema).optional() }).optional(),
  props: z.object({
    layout: z.enum(['row', 'column', 'grid']),
    buttons: z.array(z.object({
      id: z.string().min(1),
      label: z.string().max(60),
      action: ActionSchema
    }))
  })
});